module.exports = "/assets/data/c7bcd683dad6805812c839a6b7ed67e6-CF82.data.json";